import React from "react";
import {
  MDBNavbar,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBNavbarToggler,
  MDBContainer,
  MDBIcon,
  MDBBtn,
  MDBNavbarBrand,
  MDBCollapse,
} from "mdb-react-ui-kit";

import { LoginForm } from "Projects/SSO_single_sign_on_project/Components/LoginForm/LoginForm";
import { CircleImage } from "Projects/CC_cubi_clan_project/GlobalComponents/CircleImage/CircleImage";
import {
  getFileFraming,
  getFileVariants,
  mfmFramedUrl,
  mfmMediumUrl,
  mfmVariantUrl,
} from "Projects/CC_cubi_clan_project/Utils/MfmService";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { acceptSession, clearSession, getSessionProfile, restoreSession } from "Projects/CC_cubi_clan_project/Utils/SessionManager";
import { toast } from "Projects/CC_cubi_clan_project/GlobalComponents/ToastHost/ToastHost";
import eventBus from "Projects/CC_cubi_clan_project/Utils/EventBus";
import profile_default from "images/profile_default.png";
import cubimg from "images/cubimg.jpeg";
import CubeWorkspaceMenu from "Projects/CC_cubi_clan_project/GlobalComponents/CubeWorkspaceMenu/CubeWorkspaceMenu";

import "./NavMenu.css";

const DEFAULT_COOKIE_NAME = "SESSION_ID";

function getCookie(name) {
  try {
    const map = (document.cookie || "").split(";").reduce((acc, p) => {
      const i = p.indexOf("=");
      if (i > -1)
        acc[decodeURIComponent(p.slice(0, i).trim())] = decodeURIComponent(
          p.slice(i + 1).trim()
        );
      return acc;
    }, {});
    return map[name] || null;
  } catch (_) {
    return null;
  }
}

export class NavMenu extends React.Component {
  static defaultProps = {
    title: "",
    navMenu: [],
    logoImg: cubimg,
    sessionCookieName: DEFAULT_COOKIE_NAME,
    pollMs: 1500,
    onLoginClick: null, // opcional
    onLogout: null, // opcional
    onHandleNavLinks: null, // opcional
    onNavigate: null, // opcional
    onLoading: null, // opcional
    isLoggedIn: undefined, // opcional; si no se pasa, se calcula por cookie
    statusChip: null,
    appCode: null,
    sessionManaged: false,
    navigationVariant: "legacy",
    navigationGroups: [],
    navigationPathname: "",
    navigationSearch: "",
    onWorkspaceNavigate: null,
  };

  constructor(props) {
    super(props);

    const userDataJson = sessionStorage.getItem("userData");
    const userData = getSessionProfile() || (userDataJson ? JSON.parse(userDataJson) : null);
    const initialIsLoggedIn =
      typeof props.isLoggedIn === "boolean" ? props.isLoggedIn : !!getSessionProfile();

    this.state = {
      title: props.title,
      isLoading: false,
      showBasic: false,
      showLoginModal: false,
      isLoggedIn: initialIsLoggedIn,
      navMenu: props.navMenu,
      user: userData,
      logoImg: props.logoImg ?? cubimg,
      avatarVariantKey: null,
      avatarVariantUuid: null,
      appEstado: null,
    };

    this.lastSessionId = null;
    this._authEpoch = 0;
    this._profileHydrating = false;
    // sessionStorage is only a display cache. Authentication is always restored
    // from the server so reload also works with non-JavaScript-readable cookies.
    this._profileLoaded = false;
    this._avatarVariantRequestId = 0;

    // Bind para listeners con la misma referencia
    this.onCookieStoreChange = this.onCookieStoreChange.bind(this);
    this.checkSessionCookie = this.checkSessionCookie.bind(this);
    this.onWindowFocus = this.onWindowFocus.bind(this);
    this.toggleShowBasic = this.toggleShowBasic.bind(this);
    this.handleNavLinks = this.handleNavLinks.bind(this);
    this.handleUserUpdated = this.handleUserUpdated.bind(this);
    this.loadAppEstado = this.loadAppEstado.bind(this);
  }

  componentDidMount() {
    if (!this.props.sessionManaged) window.addEventListener("focus", this.onWindowFocus);

    // Suscripción a cambios externos de usuario
    if (eventBus?.subscribe) {
      eventBus.subscribe("userUpdated", this.handleUserUpdated);
    }

    if (!this.props.sessionManaged) this.hydrateUserDataFromProfile();
    this.hydrateAvatarVariantFromUuid(this.state.user?.imageUuid);
    this.loadAppEstado();
  }

  componentDidUpdate(prevProps, prevState) {
    const prevUuid = typeof prevState.user?.imageUuid === "string" ? prevState.user.imageUuid.trim() : "";
    const nextUuid = typeof this.state.user?.imageUuid === "string" ? this.state.user.imageUuid.trim() : "";
    if (prevUuid !== nextUuid) {
      this.hydrateAvatarVariantFromUuid(nextUuid);
    }

    if (prevProps.appCode !== this.props.appCode) {
      this.loadAppEstado();
    }
  }

  componentWillUnmount() {
    if (window.cookieStore?.removeEventListener) {
      window.cookieStore.removeEventListener(
        "change",
        this.onCookieStoreChange
      );
    }
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
    window.removeEventListener("focus", this.onWindowFocus);

    if (eventBus?.unsubscribe) {
      eventBus.unsubscribe("userUpdated", this.handleUserUpdated);
    }
  }

  // --- Cookie events / sync ---
  onCookieStoreChange(e) {
    const name = this.props.sessionCookieName;
    const relevant =
      (e.changed || []).some((c) => c.name === name) ||
      (e.deleted || []).some((c) => c.name === name);
    if (relevant) this.checkSessionCookie();
  }

  onWindowFocus() {
    this.hydrateUserDataFromProfile(true);
  }

  checkSessionCookie() {
    const name = this.props.sessionCookieName;
    const value = getCookie(name);
    if (value !== this.lastSessionId) {
      this.lastSessionId = value;
      const isLoggedIn = !!value;
      this.setState({ isLoggedIn });
      if (isLoggedIn) {
        this.hydrateUserDataFromProfile();
      } else {
        this._profileLoaded = false;
      }
    } else if (value && !this.state.user) {
      this.hydrateUserDataFromProfile();
    }
  }

  // --- Loading helpers ---
  setLoading = (loading) => {
    this.setState({ isLoading: !!loading });
    if (this.props.onLoading) {
      // pasa el evento tal cual si viene, o construye uno básico
      this.props.onLoading(loading);
    }
  };

  // --- User data helpers ---
  setUserData = (data) => {
    try {
      sessionStorage.setItem("userData", JSON.stringify(data));
    } catch (_) {}
    this.setState({ user: data });
  };

  clearUserData = () => {
    try {
      sessionStorage.removeItem("userData");
    } catch (_) {}
    this.setState({ user: null, avatarVariantKey: null, avatarVariantUuid: null });
  };

  buildAvatarVariantKey = (crop) => {
    const x = Number(crop?.x);
    const y = Number(crop?.y);
    const zoom = Number(crop?.zoom);
    if (!Number.isFinite(x) || !Number.isFinite(y) || !Number.isFinite(zoom)) return null;
    const safeX = Math.max(0, Math.min(100, x));
    const safeY = Math.max(0, Math.min(100, y));
    const safeZoom = Math.max(1, Math.min(3, zoom));
    return `framed:preset:circle:320x320:x${safeX.toFixed(3)}:y${safeY.toFixed(3)}:z${safeZoom.toFixed(3)}`;
  };

  hydrateAvatarVariantFromUuid = async (uuidRaw) => {
    const uuid = typeof uuidRaw === "string" ? uuidRaw.trim() : "";
    if (!uuid || uuid === "null" || uuid === "undefined") {
      this.setState({ avatarVariantKey: null, avatarVariantUuid: null });
      return;
    }

    if (this.state.avatarVariantUuid === uuid && this.state.avatarVariantKey) return;

    const requestId = ++this._avatarVariantRequestId;
    try {
      let framing = await getFileFraming(uuid, "preset:circle");
      if (!framing) {
        framing = await getFileFraming(uuid, "ratio:1:1");
      }
      const variants = await getFileVariants(uuid);
      if (requestId !== this._avatarVariantRequestId) return;

      const expectedKey = this.buildAvatarVariantKey(framing);
      const exact = expectedKey
        ? variants.find((v) => String(v?.variantKey || "") === expectedKey)
        : null;
      const fallbackLegacy = variants.find((v) => String(v?.variantKey || "").startsWith("framed:preset:circle:320x320:"));
      const fallbackByDimensions = variants.find((v) => {
        const key = String(v?.variantKey || "");
        const w = Number(v?.width);
        const h = Number(v?.height);
        return key.startsWith("framed:")
          && Number.isFinite(w)
          && Number.isFinite(h)
          && Math.round(w) === 320
          && Math.round(h) === 320;
      });
      const matched = exact || fallbackLegacy || fallbackByDimensions;

      this.setState({
        avatarVariantUuid: uuid,
        avatarVariantKey: matched?.variantKey ? String(matched.variantKey) : null,
      });
    } catch (_) {
      if (requestId !== this._avatarVariantRequestId) return;
      this.setState({ avatarVariantUuid: uuid, avatarVariantKey: null });
    }
  };

  hydrateUserDataFromProfile = async (force = false) => {
    if (this._profileHydrating || (this._profileLoaded && !force)) return;

    this._profileHydrating = true;
    const epoch = this._authEpoch;
    try {
      const profile = await restoreSession(undefined, { force });
      if (epoch !== this._authEpoch) return;
      if (profile) {
        this.setUserData(profile);
        this._profileLoaded = true;
        this.setState({ isLoggedIn: true });
        this.props.onLoggedIn && this.props.onLoggedIn(true);
      } else {
        this._profileLoaded = false;
        this.clearUserData();
        this.setState({ isLoggedIn: false });
        this.props.onLoggedIn && this.props.onLoggedIn(false);
      }
    } catch (_) {
      // A network failure is not proof that the server session is invalid.
    } finally {
      this._profileHydrating = false;
    }
  };

  // --- EventBus: userUpdated ---
  handleUserUpdated(payload) {
    // Soporta distintos formatos: {user, isLoggedIn}, objeto user directo, comandos
    if (payload === null) {
      this.clearUserData();
      return;
    }
    if (typeof payload === "object") {
      if (payload.command === "logout") {
        this.logout();
        return;
      }
      if (payload.user) this.setUserData(payload.user);
      else this.setUserData(payload);
      this._profileLoaded = true;
      if (typeof payload.isLoggedIn === "boolean")
        this.setState({ isLoggedIn: payload.isLoggedIn });
    }
  }

  // --- Login / Logout ---
  openLogin = () => {
    if (this.props.onLoginClick) return this.props.onLoginClick();
    this.setState({ showLoginModal: true });
  };

  closeLogin = () => this.setState({ showLoginModal: false });

  handleLoggedIn = (eventOrData) => {
    const data =
      eventOrData && eventOrData.DATA ? eventOrData.DATA : eventOrData;
    if (data) {
      acceptSession(data);
      this.setUserData(data);
    }
    this._profileLoaded = !!data;
    this.setState({ isLoggedIn: true, showLoginModal: false });
    this.props.onLoggedIn && this.props.onLoggedIn(true);
  };

  logout = async () => {
    this.setLoading(true);
    try {
      const response = await doFetch("SSO", "logout", { method: "POST", _silent: true });
      if (!response?.ok) {
        toast.error("No se pudo revocar la sesión. Continúas conectado.");
        return;
      }
      this._authEpoch += 1;
      clearSession();
      this.lastSessionId = null;
      this._profileLoaded = false;
      this.clearUserData();
      this.setState({ isLoggedIn: false });
      this.props.onLoggedIn && this.props.onLoggedIn(false);
      if (this.props.onLogout) this.props.onLogout();
      else if (this.props.onNavigate) this.props.onNavigate("/");
      else if (window.location.pathname !== "/") window.location.assign("/");
    } catch (_) {
      toast.error("No se pudo revocar la sesión. Continúas conectado.");
    } finally {
      this.setLoading(false);
    }
  };

  // --- Navegación ---
  handleNavLinks(event, url) {
    if (this.props.onHandleNavLinks)
      return this.props.onHandleNavLinks(event, url);
  }

  loadAppEstado() {
    const appCode = this.props.appCode;
    if (!appCode) {
      this.setState({ appEstado: null });
      return;
    }

    doFetch("SSO", "getAppEstado?app=" + appCode, { _silent: true })
      .then((r) => r.json())
      .then((data) => {
        if (data.STATE === "SUCCESS" && data.DATA) {
          this.setState({ appEstado: data.DATA.estado || null });
        } else {
          this.setState({ appEstado: null });
        }
      })
      .catch(() => this.setState({ appEstado: null }));
  }

  // --- UI ---
  toggleShowBasic() {
    this.setState((s) => ({ showBasic: !s.showBasic }));
  }

  render() {
    const { title, navMenu, logoImg } = this.state; // se mantienen desde state
    const { showBasic, isLoggedIn, showLoginModal, user, isLoading, avatarVariantKey, avatarVariantUuid, appEstado } =
      this.state;
    const imageUuidRaw = typeof user?.imageUuid === "string" ? user.imageUuid.trim() : "";
    const hasValidImageUuid = !!imageUuidRaw && imageUuidRaw !== "null" && imageUuidRaw !== "undefined";
    const fallbackAvatar = user?.userImg || profile_default;
    const avatarVariantSrc = hasValidImageUuid && avatarVariantUuid === imageUuidRaw && avatarVariantKey
      ? mfmVariantUrl(imageUuidRaw, avatarVariantKey)
      : null;
    const avatarFramedSrc = hasValidImageUuid
      ? mfmFramedUrl(imageUuidRaw, 320, 320, "preset:circle")
      : null;
    const avatarSrc = avatarVariantSrc
      || avatarFramedSrc
      || (hasValidImageUuid ? mfmMediumUrl(imageUuidRaw) : fallbackAvatar);
    const avatarImageStyle = undefined;

    const statusChip = this.props.statusChip || (appEstado === "DEMO"
      ? { text: "MODO DEMO", tone: "warning", icon: "flask", pulse: true }
      : null);

    return (
      <>
        {showLoginModal ? (
          <LoginForm
            showLoginModal={showLoginModal}
            onLoggedIn={this.handleLoggedIn}
            onCloseModal={this.closeLogin}
            onLoading={(loading) => this.setLoading(loading)}
            appCode={this.props.appCode}
          />
        ) : null}

        <MDBNavbar expand="lg" sticky light bgColor="white">
          <MDBContainer fluid>
            <MDBNavbarBrand>
              <div className="navmenu-brand-wrap">
                <img
                  src={logoImg}
                  height="45"
                  alt=""
                  loading="lazy"
                  className="me-3"
                />
                <div className="vr me-3" style={{ height: "40px" }}></div>
                <h2>{title}</h2>
                {statusChip && (
                  <div
                    className={`navmenu-status-chip navmenu-status-chip--${statusChip.tone || "neutral"}${statusChip.pulse ? " is-pulsing" : ""}`}
                    title={statusChip.text}
                  >
                    {statusChip.icon ? <MDBIcon fas icon={statusChip.icon} className="me-1" /> : null}
                    <span>{statusChip.text}</span>
                  </div>
                )}
              </div>
            </MDBNavbarBrand>

            <MDBNavbarToggler
              onClick={this.toggleShowBasic}
              data-target="#navbarRightAlignExample"
              aria-controls="navbarRightAlignExample"
              aria-expanded="false"
              aria-label="Toggle navigation"
              type="button"
            >
              <MDBIcon fas icon="bars" />
            </MDBNavbarToggler>

            <MDBCollapse navbar show={showBasic}>
              <MDBNavbarNav right fullWidth={false} className="mb-2 mb-lg-0">
                {this.props.navigationVariant === "workspace" ? (
                  <CubeWorkspaceMenu
                    areas={this.props.navigationGroups}
                    pathname={this.props.navigationPathname}
                    search={this.props.navigationSearch}
                    onNavigate={this.props.onWorkspaceNavigate}
                  />
                ) : null}
                {navMenu?.map((el, i) =>
                  el.visible ? (
                    <MDBNavbarItem key={i}>
                      <MDBNavbarLink
                        name={el.devName}
                        active={el.active}
                        onClick={(e) =>
                          el.onClick
                            ? el.onClick(e)
                            : this.handleNavLinks(e, el.url)
                        }
                        disabled={el.disabled}
                      >
                        {el.label}
                      </MDBNavbarLink>
                    </MDBNavbarItem>
                  ) : (
                    <div key={i}></div>
                  )
                )}

                {!showBasic ? (
                  <div className="vr me-3" style={{ height: "40px" }}></div>
                ) : (
                  <hr className="my-4" />
                )}

                {isLoggedIn ? (
                  <>
                    <MDBNavbarItem>
                      <MDBBtn
                        onClick={this.logout}
                        className="me-2"
                        type="button"
                        disabled={isLoading}
                      >
                        Desconectar
                      </MDBBtn>
                    </MDBNavbarItem>
                    <MDBNavbarItem>
                      <CircleImage
                        src={avatarSrc}
                        fallbackSrc={fallbackAvatar}
                        imageStyle={avatarImageStyle}
                        alt={user?.nombre || "user"}
                        size="45px"
                        enlargeOnHover={true}
                        onClick={() =>
                          this.handleNavLinks(
                            { target: { name: "UserDetail" } }
                          )
                        }
                      />
                    </MDBNavbarItem>
                  </>
                ) : (
                  <MDBNavbarItem>
                    <MDBBtn
                      onClick={this.openLogin}
                      className="me-2"
                      type="button"
                      disabled={isLoading}
                    >
                      Login
                    </MDBBtn>
                  </MDBNavbarItem>
                )}
              </MDBNavbarNav>
            </MDBCollapse>
          </MDBContainer>
        </MDBNavbar>
      </>
    );
  }
}
